import { getAuth, signOut } from "firebase/auth";
import { AuthScreenBase } from "./auth/AuthScreenBase";
import { RyeButton } from "./rye/RyeButton";
import { RyeModalAnchor, useRyeModal } from "./rye/RyeModal";
import { CancelSubscriptionModal } from "./settings_screen/CancelSubscriptionModal";

// Recovery needs only the Auth session. Do not mount account data providers:
// deletion may have removed the user document and some or all subcollections.
export function CancellationRecovery(): JSX.Element {
  return (
    <RyeModalAnchor>
      <RecoveryContent />
    </RyeModalAnchor>
  );
}

function RecoveryContent(): JSX.Element {
  const { openModal } = useRyeModal();
  const handleSignOut = () => {
    void signOut(getAuth()).catch(() => window.location.reload());
  };
  return (
    <AuthScreenBase
      title="Finish your cancellation"
      contentGap="sm"
      content={
        <>
          <p>
            Your cancellation has started, but some steps still need to finish.
            Continue to complete your refund and account deletion. Any refund
            already completed will not be issued again.
          </p>
          <RyeButton
            text="Continue cancellation"
            vibe="danger"
            onClick={() =>
              openModal(<CancelSubscriptionModal onCompleted={handleSignOut} />)
            }
          />
        </>
      }
      footer={{
        promptText: "Come back later?",
        actionText: "Sign out",
        onActionClick: handleSignOut,
      }}
    />
  );
}
